import { appRoles } from "#src/constants/appRoles.js";
export class UserPolicy {
    user;
    constructor(container) {
        this.user = container.user;
    }
    allowsUpdateUser(userToEdit) {
        if (!this.user) {
            return false;
        }
        if (this.user?.isAdmin) {
            return true;
        }
        return userToEdit.roles.some((r) => r.id === appRoles.Admin) ? false : true;
    }
    allowsDeleteUser(userToEdit) {
        if (!this.user) {
            return false;
        }
        if (this.user?.isAdmin) {
            return true;
        }
        return userToEdit.roles.some((r) => r.id === appRoles.Admin) ? false : true;
    }
    allowsChangePassword(userToEdit) {
        if (!this.user) {
            return false;
        }
        if (this.user?.isAdmin) {
            return true;
        }
        return userToEdit.roles.some((r) => r.id === appRoles.Admin) ? false : true;
    }
}
//# sourceMappingURL=UserPolicy.js.map